<template>
  <ReviewItemDetailsLayout
    :review-item="registration"
    :expansion-panel="expansionPanel"
    :item-url="registration.metadata.url"
  >
    <template #subtitle>
      <p
        v-if="registration.metadata.registrationId"
        class="text-sm text-neutral-text-subtitle"
      >
        {{ registration.metadata.registrationId }}
      </p>
    </template>
  </ReviewItemDetailsLayout>
</template>

<script setup lang="ts">
import ReviewItemDetailsLayout from './ReviewItemDetailsLayout.vue'
import { Registration } from '@core/domain/models/registration.model'
import useExpansionPanel from '@app/composables/use-expansion-panel'

defineProps<{
  registration: Registration
  expansionPanel: ReturnType<typeof useExpansionPanel>
}>()
</script>
